export const validateTextByEmailVariables = (text: string, allowedVars: string[]): string[] => {
  const matches = text.match(/{{([^}]+)}}/g) || []

  return matches.filter(match => {
    const varName = match.slice(2, -2).trim()

    return !allowedVars.includes(varName)
  })
}
